import React, { useContext } from "react";
import { Route, Redirect, RouteProps } from "react-router-dom";
import { UserContext } from "./UserContext";

export const PrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  const { user, loading } = useContext(UserContext);

  if (loading.loading || !loading.loaded) return null;

  const isLoggedIn = !!user.username;
  const isRegistered = user.is_registered as any;
  const needsPasswordReset = isRegistered === true || isRegistered === 1;

  return <Route {...rest}>{isLoggedIn && !needsPasswordReset ? children : <Redirect to="/login" />}</Route>;
};
